/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Swift_Plum_Fox_TuneInputs */

const en_swift_plum_fox_tune = /** @type {(inputs: Swift_Plum_Fox_TuneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apply settings to ${i?.count} selected segment(s)`)
};

const de_swift_plum_fox_tune = /** @type {(inputs: Swift_Plum_Fox_TuneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Einstellungen auf ${i?.count} ausgewählte(s) Segment(e) anwenden`)
};

/**
* | output |
* | --- |
* | "Apply settings to {count} selected segment(s)" |
*
* @param {Swift_Plum_Fox_TuneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_plum_fox_tune = /** @type {((inputs: Swift_Plum_Fox_TuneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Plum_Fox_TuneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_plum_fox_tune(inputs)
	return de_swift_plum_fox_tune(inputs)
});